import {
  getCompleteDataFormValues,
  getQuotation,
  getUserData,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import checkIfPeselIsMatchingLicenseDate from 'app/services/businessFunctions/helpers/checkIfPeselIsMatchingLicenseDate';
import { setFamilyNameVisibility } from 'app/services/businessFunctions/helpers/setFamilyNameVisibility';
import { isPeselValid } from 'app/services/pesel.service';

const ownerDetails = {
  completeDataFormOwnerPeselChange() {
    const { owner } = getCompleteDataFormValues();

    if (!owner || !owner.pesel) {
      return;
    }

    const mainOwner = getQuotation().mainOwner || {
      driverLicenseIssuedYear: 0,
      driverLicenseIssuedMonth: 0,
    };
    const driverLicenseYear = mainOwner.driverLicenseIssuedYear;
    const driverLicenseMonth = mainOwner.driverLicenseIssuedMonth;

    checkIfPeselIsMatchingLicenseDate({
      pesel: owner.pesel,
      driverLicenseYear,
      driverLicenseMonth,
      noDriverLicenseModelPath: ModelPathEnum.OwnerNoDriverLicense,
      messageKey: MessagesEnum.CompleteDataFormOwnerPeselAndLicenseYearMismatch,
      formName: FormsEnum.CompleteDataForm,
    });
  },

  completeDataFormOwnerCheckIfPeselIsMatchingGender() {
    const { owner } = getCompleteDataFormValues();
    const isOperator = getUserData().user?.operator;
    const { mainOwner } = getQuotation();

    if (
      !owner ||
      !owner.pesel ||
      !mainOwner ||
      !mainOwner.gender ||
      !isOperator
    ) {
      return;
    }

    setFamilyNameVisibility(
      FieldsEnum.CompleteDataOwnerFamilyName,
      FormsEnum.CompleteDataForm,
      owner.pesel,
      isPeselValid(owner.pesel)
    );
  },
};

export default ownerDetails;
